import { Icon, IconDefinitions } from "../../../components";
interface SectionHeaderProps {
  title: string;
  description: string;
  iconName: IconDefinitions;
  iconBgColor: string;
  borderColor: string;
  count?: number;
  countLabel?: string;
}

export function SectionHeader({
  title,
  description,
  iconName,
  iconBgColor,
  borderColor,
  count,
  countLabel = "item"
}: SectionHeaderProps) {
  return (
    <div 
      style={{
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        borderLeft: `4px solid ${borderColor}`
      }}
      className="p-3 rounded mb-4"
    >
      <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-3">
        <div className="d-flex align-items-center gap-3 flex-grow-1">
          <div 
            style={{
              width: '48px',
              height: '48px',
              minWidth: '48px',
              background: iconBgColor
            }}
            className="rounded d-flex align-items-center justify-content-center text-white fs-5"
          >
            <Icon iconName={iconName as string} />
          </div>
          <div className="flex-grow-1">
            <h4 className="mb-0 fw-semibold" style={{ fontSize: '1.1rem', color: '#212529' }}>
              {title}
            </h4>
            <small className="text-muted d-block" style={{ fontSize: '0.85rem' }}>
              {description}
            </small>
          </div>
        </div>
        {count !== undefined && (
          <span className="badge bg-light text-dark align-self-start align-self-sm-center text-nowrap">
            {count} {countLabel}{count !== 1 ? 's' : ''}
          </span>
        )}
      </div>
    </div>
  );
}

export default SectionHeader;